import * as React from 'react'
import { useState, useContext, ReactElement } from 'react';
import { AppContext } from '../../../Context/AppContext';
import { postier } from './Postier';



export function InsertHour({setPagina}): ReactElement {

    const {token,site,client,setLoading, setErrors} = useContext(AppContext)


    const [fields, setFields] = useState({WeekDay:'1',FromDate:"2022-01-01",ToDate:"2040-12-31",Opening:"07:00:00",Closing:"07:00:00",MiddayClosing:"07:00:00",MidddayOpening:"07:00:00"})

    const [jours, setJours] = useState([
            {name:"lundi",day:"1",state:false},
            {name:"mardi",day:"2",state:false},
            {name:"mercredi",day:"3",state:false},
            {name:"jeudi",day:"4",state:false},
            {name:"vendredi",day:"5",state:false},
            {name:"samedi",day:"6",state:false},
            {name:"dimanche",day:"0",state:false}
        ]
        )

        const [update, setUpdate] = useState<boolean>(false)

        // useEffect(() => {
        //     console.log({jours})
        // }, [jours,update])

    const handleChange = (field: string, e) => {
        const fieldsCopy = fields;
        fieldsCopy[field] = e.target.value;
        setFields(fieldsCopy);
    };

    const handleDays = (name: string, e) => {
        const fieldsCopy = jours;
        console.log("click")

        for (const jour of fieldsCopy) {
            if (jour.name==name){

                jour["state"]=!jour.state


            }
        }

        setUpdate(!update)

        setJours(fieldsCopy);
    };

    const submit = async ()=>{

        let {WeekDay,FromDate,ToDate,Opening,Closing,MiddayClosing,MidddayOpening} = fields
        
        const data = {
            jours,
            WeekDay: parseInt(WeekDay),
            FromDate:FromDate + " "+ "23:59:59",
            ToDate:ToDate + " "+ "23:59:59",
            Opening,
            Closing,
            MiddayClosing,
            MidddayOpening
        }
        // console.log("send Days ---------\n",{data})

        setLoading(true)

        postier.updateHoraire(token,client,site,setLoading,setPagina,data, setErrors)

    }

    return (
        <div className="form">
            <h2>Nouvel horaire</h2>
            <label>Jours</label>
            
            <div className="line" >
                {
                    jours.map((j,i)=>{
                        return <div className="checkbox" key={i}><label >{j.name}</label><input type="checkbox" onChange={e=>handleDays(j.name,e)} checked={j.state}  /></div>
                    })
                }
                
            </div>
            <label>Date de début</label>
            <input type="date" defaultValue={fields.FromDate} onChange={e=>handleChange('FromDate',e)} />
            <label>Date de fin</label>
            <input type="date"  defaultValue={fields.ToDate} onChange={e=>handleChange('ToDate',e)}  />
            <label>Ouverture</label>
            <input type="time"  defaultValue={fields.Opening} onChange={e=>handleChange('Opening',e)}  />
            <label>Début de pause</label>
            <input type="time" defaultValue={fields.MiddayClosing} onChange={e=>handleChange('MiddayClosing',e)} />
            <label>Fin de pause</label>
            <input type="time" defaultValue={fields.MidddayOpening} onChange={e=>handleChange('MidddayOpening',e)}  />
            <label>Fermture</label>
            <input type="time" defaultValue={fields.Closing} onChange={e=>handleChange('Closing',e)}  />
            <button onClick={submit} >Appliquer nouvel horaire</button>
        </div>
    )
}
